import { render, staticRenderFns } from "./TInput.vue?vue&type=template&id=34476634&scoped=true"
import script from "./TInput.vue?vue&type=script&setup=true&lang=js"
export * from "./TInput.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TInput.vue?vue&type=style&index=0&id=34476634&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34476634",
  null
  
)

export default component.exports